<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div class="mask"
         key="1"
         @click.self="show = false"
         v-if="show"
         :class="activeName"
         @touchmove.prevent>
    <div class="new-user"
         v-show="show"
         :style="swiperStyle"
         :class="specialName">
        <div
          v-if="isGeshenScene"
          class="geshen-copy"
          :style="swiperBoxStyle"
        >
          <p class="geshen-copy-text">{{ personalizedText }}</p>
        </div>
        <div
          v-else-if="swiperData.length > 1"
          class="swiper-wrappper"
          :style="swiperBoxStyle"
          :class="bulletName"
        >
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in swiperData" :key='index'>
              <img :src="item">
            </swiper-slide>
            <div
              v-if="swiperData.length>1"
              class="swiper-pagination"
              slot="pagination"
            >
            </div>
          </swiper>
        </div>
        <ul :class="packageName">
          <li v-for="(item,index) in packages"
            :key='index'
            :class="{
              'selected': index === selectIndex
            }"
            @click="choosePackage(index)"
          >
            <div class="desc">
              {{ item.desc.split('plus')[0] }}
              <img v-if="item.desc.includes('plus')" :src="newTip"/>
            </div>
            <div class="month-price">
              ¥<span>{{ item.day_fee }}</span>{{ item.desc==='24小时' ? '' : '/日' }}
            </div>
            <!-- 月会员调整 -->
            <div v-if="index!=0" class="price" :style="index===0 && 'textDecoration:line-through'">
              ¥{{ index===0? item.origin_fee: item.current_fee / 100 }}
            </div>
            <div v-if="item.save_tip" class="tag">{{ item.save_tip }}</div>
          </li>
        </ul>
        <GiveFriend v-if="isShowGiveFriend" @presentVipClick="presentVipClick" :presentVipSelected="isChooseGiveFriend" :config="giveFriendConfig"></GiveFriend>
        <div :class="[showFootbar && 'foot-bar', btnClass]" :style="btnStyle">
          <div class="pay-button" @click="handleClickBuyButton" :style="btnStyle">
            <img v-if="playSong && songItem.sno" src="https://qncweb-back1.ktvsky.com/20220920/vadd/cc07e718e228c09afe893c9ec6540d81.png" class="pay-button-tip">
          </div>
          <div v-if="playSong && songItem.sno" class="play-song" @click="handleClickPlaySong"></div>
        </div>
        <div v-if="showAgreement" class="agreement" @click="handleClickAgreement"></div>
        <div v-if="singlePointCallback" class="single-point" @click="handleClickSinglePoint"></div>
        <div v-if="isDownTime" class="down_time">00:{{minute}}:{{second}}后过期</div>
        <img @click="closePayMent"
           class="close"
           src="../adsense/static/close.png">
    </div>
  </div>
  </transition-group>
</template>
<script>
import { mapState } from 'vuex';
import { utils } from '@/libs/interfaces';
import { reportPay } from '@/libs/utils/log/log';
import mixinOldVip from '@/mixins/vip-toast-test';
import store from '@/store'
import GiveFriend from '@/components/app/giveFriend'

export default {
  name: 'RaisePaymentMessage',
  mixins: [mixinOldVip],
  data() {
    return {
      show: false,
      packages: [],
      selectIndex: 0,
      swiperData: [],
      swiperOption: {
        pagination: { el: '.swiper-pagination' },
        preventLinksPropagation: false,
        watchOverflow: true,
        loop: true,
        autoplay: { disableOnInteraction: false },
      },
      page_tp: '',
      singlePointCallback: null,
      swiperStyle: '',
      minutes: 3,
      seconds: 0,
      isDownTime: false,
      specialName: '',
      bulletName: '',
      activeName: '',
      playSong: null,
      packageName: '',
      enterTime: 0,
      memberIdArr: [103, 104, 105],
      callback: null,
      songItem: {},
      isShowGiveFriend: false,
      isChooseGiveFriend: false,
      giveFriendConfig: {
        color: '#c61c0b',
        bg: 'https://qncweb-back1.ktvsky.com/20211126/vadd/582698c79a3e78b2e056cd61e3e3f054.png',
        point: 'https://qncweb-back1.ktvsky.com/20211126/vadd/8287524e9efe3c74424841a7677ddea9.png',
      },
      ignoreDialogScene: [
        '1年plus',
        '3个月',
      ],
      btnClass: '',
      showAgreement: false, // 用户协议入口
    };
  },
  components: {
    GiveFriend,
  },
  watch: {
    second: {
      handler(newVal) {
        this.num(newVal);
      },
    },
    minute: {
      handler(newVal) {
        this.num(newVal);
      },
    },
  },
  computed: {
    ...mapState({
      is_plusvip: (state) => state.is_plusvip,
      role: (state) => state.role,
    }),
    second() {
      return this.num(this.seconds);
    },
    minute() {
      return this.num(this.minutes);
    },
    newTip() {
      // eslint-disable-next-line
      return this.isDownTime ? 'https://qncweb-back1.ktvsky.com/20210617/vadd/9ac911c3078bba75b76676f65b609d56.png' : this.page_tp == 'new_djlive' ? 'https://qncweb-back1.ktvsky.com/20210701/vadd/1951012cffb55102526adec73cb41fef.png' : require('../play_control/plus/icon_plus.png');
    },
    showFootbar() {
      const types = ['geshen', 'djhot']
      return types.includes(this.songItem.type)
    },
    isGeshenScene() {
      return this.songItem.type === 'geshen'
        && (this.role === 'role4' || this.role === 'role5')
    },
    personalizedText() {
      if (this.songItem.music_name) {
        return `想唱《${this.songItem.music_name}》？开通即可高清点唱`
      }
      if (this.songItem.singer) {
        return `${this.songItem.singer}的歌 开通即唱高清版`
      }
      return ''
    },
  },
  methods: {
    handleClickAgreement() {
      this.event.$store.commit('SAVE_AGREE_SHOW', true)
      this.$sendLog({
        event_type: 'click',
        event_name: '用户协议',
        event_data: {
          name: '弹窗',
        },
      });
    },
    choosePackage(index) {
      this.selectIndex = index;
    },
    handleClickBuyButton() {
      const { presentVipPackages } = store.state;
      let item = null
      let pay_enter = this.page_tp
      if (this.isChooseGiveFriend) {
        item = presentVipPackages[this.selectIndex];
        pay_enter = `${this.page_tp}_present_vip`
      } else {
        item = this.packages[this.selectIndex];
      }
      reportPay({
        page_tp: pay_enter,
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 0,
        tc_tp: item.pkg_id,
      });
      if (this.statName) {
        this.$sendLog({
          event_type: 'click',
          event_name: this.statName,
          event_data: {
            name: `开通${item.desc}会员按钮`,
          },
        });
      }
      store.commit('SET_ORDER_LIST', true)
      // 首页VIP歌曲打点区分：https://m2miovoqda.feishu.cn/wiki/wikcngPVPhzDrH4uwyeo1uFjFGb
      if (this.songItem.songid && this.event.$route.name === 'home') {
        pay_enter = `${pay_enter}_home`
      }
      utils.util.buyVipPlus({
        memberId: this.isDownTime ? this.memberIdArr[this.selectIndex] : item.pkg_id,
        pay_fee: item.current_fee,
        pay_enter,
        $this: this.event,
        vipSongInfo: this.songItem,
        isChooseGiveFriend: this.isChooseGiveFriend,
        callback: () => {
          this.show = false;
          this.event.$store.commit('SAVE_IS_VIP');
          if (!this.ignoreDialogScene.includes(item.desc)) {
            this.event.$sendLog({
              event_type: 'show',
              event_name: `${item.desc}会员开通成功弹窗`,
            });
            this.event.$store.commit('SAVE_HOME_TOAST', false);
            // 新三档支付成功弹窗在util里处理
            // this.$RaiseMessage.close(true);
            // this.event.$store.commit('SET_VIP_PACKAGES_TOAST');
            if (this.songItem && Object.keys(this.songItem).length > 0) { // 判断songItem不为{}
              this.event.orderSong('1', this.songItem);
            }
          }
        },
        giveFriendSuccess: () => {
          if (this.songItem) {
            this.event.orderSong('1', this.songItem);
          }
        },
      });
    },
    getPackages() {
      this.event.$store.dispatch('getData', {
        keyName: 'vip_old',
        callback: (res) => {
          const ShowVip = [1, 30];
          const plus = res.data.pop();
          const packages = res.data.filter((item) => ShowVip.includes(item.days));
          this.packages = packages.reverse().concat(plus);
        },
      });
    },
    presentVipClick() {
      this.isChooseGiveFriend = !this.isChooseGiveFriend
    },
    handlePageUnload() {
      reportPay({
        page_tp: this.page_tp,
        active_tp: 1, // 用户行为：0：点击 ;1：停留
        stay_time: Date.now() - this.enterTime, // 停留时间(单位：毫秒)
      });
    },
    num(n) {
      return n < 10 ? `0${n}` : `${n}`;
    },
    add() {
      const context = this;
      const time = window.setInterval(() => {
        if (context.seconds === 0 && context.minutes !== 0) {
          context.seconds = 59;
          context.minutes -= 1;
        } else if (context.minutes === 0 && context.seconds === 0) {
          context.seconds = 0;
          window.clearInterval(time);
        } else {
          context.seconds -= 1;
        }
      }, 1000);
    },
    handleClickPlaySong() {
      this.event.$sendLog({
        event_type: 'click',
        event_name: `点击演唱${this.songItem.type}普通版按钮`,
        event_data: {
          tp: this.page_tp,
          route: this.event.$route.name,
        },
      });
      this.show = false;
      store.commit('SET_ORDER_LIST', true)
      this.playSong();
    },
    handleClickSinglePoint() {
      reportPay({
        page_tp: 'wuqu_song_5.9',
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 0,
      });
      this.event.$store.dispatch('buySinglePoint', {
        entrance: 'wuqu_song_5.9',
        pay_fee: 590,
        song_id: this.songItem.songid,
        song_name: this.songItem.music_name,
        callback: () => {
          this.show = false;
          this.singlePointCallback();
        },
      });
    },
    closePayMent() {
      this.show = false;
      store.commit('SET_ORDER_LIST', true)
    },
  },
  mounted() {
    if (!store.state.intervalShowOrderList) {
      store.commit('SET_ORDER_LIST', false)
    }
    this.enterTime = Date.now();
    this.getPackages();
    window.addEventListener('beforeunload', this.handlePageUnload);
    reportPay({
      page_tp: this.page_tp,
      active_tp: 3, // 用户行为：0：点击 ;1：停留
    });
    // 有倒计时
    if (this.isDownTime) {
      this.add();
    }
    if (!store.state.isSupportInteract && this.swiperData.length) {
      this.swiperData = [
        'https://qncweb-back1.ktvsky.com/20210616/vadd/f35f73a4f2eb05e376fcb2ce43ad1715.png',
      ]
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handlePageUnload);
  },
};
</script>
<style lang="scss" scoped>
// 全局弹窗
.mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
.new-user {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -53px;
  width: 630px;
  height: 689px;
  background-image: url('https://qncweb-back1.ktvsky.com/20210607/vadd/17db655b455e16cb2ad63e753721d225.png');
  background-repeat:  no-repeat;
  background-size: 100% auto;
  background-position: center bottom;
  padding-top: 35vw;
}
.openvip {
  width: 400px;
  height: 74px;
  margin: 65px auto 0;
}
.close {
  width: 54px;
  position: absolute;
  right: -20px;
  top: -74px;
}
.vip-packages {
  width: 750px;
  height: 832px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: url('../play_control/plus/bg.png') no-repeat;
  background-size: 100% 100%;
}
ul {
  display: flex;
  justify-content: space-between;
  margin: 0px 52px;
  text-align: center;
  li {
    position: relative;
    width: 168px;
    height: 216px;
    background: url('../play_control/plus/background.png') no-repeat;
    background-size: 100% 100%;
  }
  .selected {
    background: url('https://qncweb-back1.ktvsky.com/20210719/vadd/5872c9d61a5948b79abff4f867f43153.png') no-repeat;
    background-size: 100% 100%;
    .desc {
        color: #ffffff;
    }
    .month-price {
        color: #edd7b3;
    }
    .price {
        color: #ffffff;
    }
  }
  .item-plus {
    .month-price {
      margin-top: -10px;
      margin-bottom: 30px;
    }
  }
  .tag {
    position: absolute;
    left: 0;
    top: -8px;
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    background: #F2483D;
    padding: 0 10px;
    border-radius: 10px 0px 10px 0px;
    color: #f8f8fa;
  }
  .desc {
    position: relative;
    margin-top: 30px;
    font-size: 29px;
    font-weight: 500;
    color: #4a4949;
    font-weight: bold;
    display: inline-block;
    img {
      position: absolute;
      width: 55px;
      top: -2px;
      right: -55px;
    }
  }
  .month-price {
    margin: 17px 0 14px;
    font-size: 24px;
    font-weight: 400;
    color:#FA810D;
    span {
      font-size: 36px;
      padding: 0 5px 0 10px;
      font-weight: 500;
    }
  }
  .price {
    font-size: 24px;
    font-weight: 400;
    color: #7b7676;
  }
  .tip {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 168px;
    height: 33px;
    line-height: 34px;
    background: #3B2B0D;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
  }
  .icon-app {
    position: absolute;
    top: 115px;
    left: 50%;
    margin-left: -60px;
    width: 120px;
  }
}
.pay-button {
  width: 558px;
  height: 100px;
  margin: 80px auto 0;
}
.single-point {
  width: 100%;
  height: 60px;
  margin-top: 20px;
}
.other-rights {
  text-align: center;
  font-size: 22px;
  color: #ABA18E;
  margin: 20px 0 ;
  i {
    font-style: normal;
    font-size: 22px;
    text-decoration: underline;
  }
}
.plus-vip {
  border-top: 20px solid #f8f8fa;
  img {
    width: 731px;
    height: 355px;
    margin-left: 10px;
  }
}
.bigScreen1 {
  ::v-deep .swiper-pagination-bullet {
    background: #9FA0A0!important;
    opacity:1!important;
    &-active {
      background: #FFFFFF!important;
    }
  }
}
.bigScreen2 {
  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet {
    background: #8f7e60!important;
    opacity:1!important;
    &-active {
      background: #090602!important;
      }
    }
  }
}
.bigScreen3 {
  ::v-deep .swiper-pagination-bullet {
    background: #F8E37D!important;
    opacity:1!important;
    &-active {
      background: #B3371A!important;
    }
  }
 }
 .bigScreen4 {
  ::v-deep .swiper-pagination-bullet {
    background: #9FA0A0!important;
    opacity:1!important;
    &-active {
      background: #fff!important;
    }
  }
 }
 .bigScreen5 {
  ::v-deep .swiper-pagination-bullet {
    background: #b3371a!important;
    opacity:1!important;
    &-active {
      background: #f8e37d!important;
    }
  }
 }
.geshen-copy {
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  .geshen-copy-text {
    font-size: 28px;
    font-weight: bold;
    color: #4a4949;
    text-align: center;
    line-height: 1.5;
    padding: 20px;
  }
}
.swiper-wrappper {
  width: 80%;
  margin: 0 auto;
  ::v-deep .swiper-slide{
      padding: 0px 20px;
  }
  .swiper-pagination {
    position: relative;
    ::v-deep .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #221010;
      margin: 0 6px;
      &-active {
        background: #3b1d1d;
      }
    }
  }
}
.special {
  ul {
    li {
      background: #ff9999;
      border-radius: 10px;
    }
    .desc, .month-price, .price{
      color: #420100;
    }
    .tip {
      color: #FF9999;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .tag {
      background: url('https://qncweb-back1.ktvsky.com/20210617/vadd/e928298c6d1660ec967a3199ce82577a.png') no-repeat;
      background-size: 100%;
      color: #EE0C30;
    }
  }
  ul .selected {
    background: linear-gradient(0deg,#ffc22d 0%, #fff3d6 100%);
    border-radius: 10px;
    .desc, .month-price, .price{
      color: #EE0C30;
    }
  }
}
.special1 {
    ul {
        margin:0px 26px!important;
    }
    width: 580px!important;
}
.down_time {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  color: #ffe8bb;
}
.play-song {
  width: 558px;
  height: 60px;
  margin: 5px auto 0;
}
.agreement {
  width: 100%;
  height: 70px;
}
ul.packageOne {
  .tip {
    background: #FFD94D;
    color: #271D09;
  }
}
ul.packageTwo {
  .tip {
    background: #3b2b0d;
    color: #fff;
  }
}
.packageFive {
  li {
    background: #bf30ce;
    border-radius: 10px;
  }
  .desc, .month-price, .price{
    color: #ffe7aa;
  }
  .tip {
    background: #ffe7aa;
    color: #bf30ce;
  }
  .tag {
    background: url('https://qncweb-back1.ktvsky.com/20210701/vadd/e2f5104497a1f01e15769531f3d9f83f.png') no-repeat;
    background-size: 100%;
    color: #ee0c30;
    font-weight: 400;
  }
  .selected {
    background: linear-gradient(0deg,#ffc22d 0%, #fff3d6 100%);
    border-radius: 10px;
    .desc, .month-price, .price{
      color: #EE0C30;
    }
  }
}
.active_one {
  ul {
    .selected {
      background: url('https://qncweb-back1.ktvsky.com/20210705/vadd/ad53c0e1671102f000dbddda453721f3.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
.active_two {
  ul {
    .selected {
      background: url('https://qncweb-back1.ktvsky.com/20210705/vadd/ad53c0e1671102f000dbddda453721f3.png') no-repeat;
      background-size: 100% 100%;
    }
    .tip {
      background: #FFD94D;
      color: #271D09;
      font-size: 18px;
    }
  }
}
.orderSong {
  transform: translate(-50%,-50%) scale(0.95);
  transform-origin: center;
  .month-price {
    color: #341FF8!important;
  }
  .selected {
    border: 2px solid #3926F0;
    background: #E7F4FF;
    border-radius: 16px;
    .desc {
      color: #4A4949;
    }
    .month-price {
      color: #341FF8!important;
    }
    .price {
      color: #7B7676;
    }
  }
  .tip {
    background: #331FF8;
  }
}
.foot-bar {
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
  align-items: center;
  height: 22vw;
  margin: 0 24px;
  & > * {
    margin: 0;
    width: 280px;
  }
  .play-song {
    background: url(https://qncweb-back1.ktvsky.com/20220211/vadd/1c86fb6069496a4893483becd5d8b119.png) no-repeat center;
    height: 100%;
    background-size: 100% auto;
  }
  .pay-button {
    background: url(https://qncweb-back1.ktvsky.com/20220913/other/c11aec629531f85ed99911821a4a4340.png) no-repeat center;
    background-size: 100% auto;
    margin-top: 0!important;
    position: relative;
  }
  .pay-button-tip {
    width: 90px;
    height: 34px;
    display: block;
    position: absolute;
    top: -14px;
    right: -10px;
  }
  div:only-child {
    width: 100%;
    background-image: url(https://qncweb-back1.ktvsky.com/20220211/vadd/a476772f21af3d022dd61314dc6f2d0f.png);
    background-size: 360px auto;
    margin: 0 auto;
  }
}
.new-foot-bar {
  .play-song {
    background: url(https://qncweb-back1.ktvsky.com/20230207/vadd/1394622249a8f419424c30a37ca20d9d.png) no-repeat center;
    height: 100%;
    background-size: 100% auto;
  }
  .pay-button {
    background: url(https://qncweb-back1.ktvsky.com/20230207/vadd/104d4b0c655987b367693dec88b0e555.png) no-repeat center;
    background-size: 100% auto;
    margin-top: 0!important;
    position: relative;
    animation-duration: 0.8s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: HeartBeat;
  }
  .pay-button-tip {
    display: none;
  }
}
@keyframes HeartBeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
</style>
